<script>
import axios from 'axios';
import router from '@/router';
import Header from '@/components/front/Header';
import Footer from '@/components/front/Footer';
import Swal from 'sweetalert2';
import moment from 'moment';
export default {
	page: {
		title: 'Volunteer System',
		meta: [
			{
				name: 'Volunteer System',
			},
		],
	},
	components: { Header, Footer },
	data() {
		return {
			title: '',
			items: [
				{
					text: '',
					href: '/',
				},
			],
			submitData: {
				user_type_id: '',
				status: 'applicant',
			},
			categories: [],
			roles: [],
			role_ids: [],
			availableRoles: {},
			userTypeId: null,
			userName: null,
			userId: null,
			assignedRoles: {},
			isLoading: false,
			noRecord: false,
			userData: JSON.parse(localStorage.getItem('web_user')),
			reScheduleRequestForm: {
				user_id: this.userId,
				role: null,
				building: null,
				location: null,
				time: null,
				date: null,
				comment: null,
				approver_id: null,
			},
			contactInfoForm: {
				username: '',
				status: '',
				avatar: '',
				t_shirt: '',
				email: '',
				address: '',
				phone: '',
				city: '',
				state: '',
				zip_code: '',
				age: '',
				gender: '',
				DOB: '',
				address2: '',
				mobile: '',
			},
			roleFilterForm: {
				role_id: null,
				category_id: null,
				start_date: null,
				end_date: null,
			},
			sendRoleRequestData: {
				user_id: null,
				role_ids: null,
			},
			typeSubmit: false,
		};
	},
	mounted() {
		this.userId = this.userData.id;
		this.getAssignedRoles();
		this.getContactDetail();
		this.filterAvailableRoles();
	},
	methods: {
		getContactDetail() {
			var token = this.userData.token;
			var config = {
				headers: { Authorization: 'Bearer ' + token },
			};
			if (token) {
				axios
					.get('user/' + this.userId, config)
					.then((res) => {
						if (res.status == 200) {
							this.contactInfoForm = res.data.response;
							this.userName = this.contactInfoForm.username;
						}
					})
					.catch((err) => {
						if (err.response) {
							console.log(err.response.data.error.message);
							if (err.response.status == 401) {
								this.logout();
							}
						}
					});
			}
		},

		getAssignedRoles() {
			this.isLoading = true;
			this.noRecord = false;
			var config = {
				headers: {
					Authorization: 'Bearer ' + this.userData.token,
					Accept: 'application/json',
				},
			};
			axios
				.get('schedule/users/assignment/' + this.userId, config)
				.then((res) => {
					this.assignedRoles = res.data.response;
					this.isLoading = false;
					if (!this.assignedRoles.length) {
						this.noRecord = true;
					}
				})
				.catch((err) => {
					if (err.response) {
						if (err.response.status == 404) {
							this.noRecord = true;
							this.isLoading = false;
						}
						if (err.response.status == 401) {
							this.logout();
						}
					}
				});
		},
		filterAvailableRoles() {
			let filter = '?location_id=' + this.userData.location_id;
			if (this.roleFilterForm.role_id) {
				filter += '&role_id=' + this.roleFilterForm.role_id;
			}
			if (this.roleFilterForm.category_id) {
				filter += '&category_id=' + this.roleFilterForm.category_id;
			}
			if (this.roleFilterForm.start_date && this.roleFilterForm.end_date) {
				filter += '&start_date=' + this.roleFilterForm.start_date;
				filter += '&end_date=' + this.roleFilterForm.end_date;
			}

			var config = {
				headers: {
					Authorization: 'Bearer ' + this.userData.token,
					Accept: 'application/json',
				},
			};
			axios
				.get('roles_by_filters' + filter, config)
				.then((res) => {
					this.availableRoles = res.data.response.roles;
					this.roles = [];
					res.data.response.role_options.forEach((role) => {
						this.roles.push({ value: role.id, text: role.name });
					});
					this.categories = [];
					res.data.response.category_options.forEach((category) => {
						this.categories.push({ value: category.id, text: category.name });
					});
				})
				.catch((err) => {
					if (err.response) {
						if (err.response.status == 404) {
							console.log('No Record Found');
						}
						if (err.response.status == 401) {
							this.logout();
						}
					}
				});
		},

		pushRoleId(event) {
			let value = event.target.value;
			if (event.target.checked == true) {
				this.role_ids.push(parseInt(value));
			} else {
				this.role_ids.forEach((role_id, index) => {
					if (role_id == value) {
						this.role_ids.splice(index, 1);
					}
				});
			}
		},

		dateFormatter(value) {
			return moment(value).format('MM/DD/YYYY');
		},
		showScheduleRequestModal(index) {
			let role = this.assignedRoles[index];
			this.reScheduleRequestForm.user_id = this.userId;
			this.reScheduleRequestForm.role = role.role;
			this.reScheduleRequestForm.building = role.building;
			this.reScheduleRequestForm.location = role.location;
			this.reScheduleRequestForm.date = role.date;
			this.reScheduleRequestForm.time = role.start_time + ' to ' + role.end_time;
			this.reScheduleRequestForm.approver_id = role.approver_id;
			this.$bvModal.show('scheduleRequestModal');
		},
		sendRequest() {
			this.typeSubmit = true;
			var config = {
				headers: {
					Authorization: 'Bearer ' + this.userData.token,
					Accept: 'application/json',
				},
			};
			axios
				.post('send_reschedule_request', this.reScheduleRequestForm, config)
				.then((res) => {
					this.typeSubmit = false;
					if (res.status == 200) {
						Swal.fire({
							title: 'Success!',
							text: 'Request has been Sent!',
							icon: 'success',
							width: 350,
							showConfirmButton: false,
							timer: 1500,
						});
						this.$bvModal.hide('scheduleRequestModal');
					}
				})
				.catch((err) => {
					this.typeSubmit = false;
					if (err.response) {
						if (err.response.status == 404) {
							console.log('No Record Found');
						}
						if (err.response.status == 401) {
							this.logout();
						}
					}
				});
		},
		sendRoleRequest() {
			if (this.role_ids.length > 0) {
				this.sendRoleRequestData.role_ids = this.role_ids;
				this.sendRoleRequestData.user_id = this.userData.id;

				var config = {
					headers: {
						Authorization: 'Bearer ' + this.userData.token,
						Accept: 'application/json',
					},
				};
				axios
					.post('sendrolerequest', this.sendRoleRequestData, config)
					.then((res) => {
						if (res.status == 200) {
							Swal.fire({
								title: 'Success!',
								text: 'Request has been Sent!',
								icon: 'success',
								width: 350,
								showConfirmButton: false,
								timer: 1500,
							});

							this.$bvModal.hide('availableRolesModal');
						}
					})
					.catch((err) => {
						if (err.response) {
							if (err.response.status == 404) {
								console.log('No Record Found');
							}
							if (err.response.status == 401) {
								this.logout();
							}
						}
					});
			} else {
				alert('please select one of the available roles');
			}
		},
		showAvailableRolesModal() {
			router.push({ name: 'available_roles' });
		},
		gotoRoles() {
			router.push({ name: 'volunteer-roles' });
		},
		gotoMentorHours() {
			router.push({ name: 'mentor-hours' });
		},
		loginPage() {
			router.push({ name: 'login' });
		},
		gotoProfile() {
			router.push({ name: 'profile' });
		},
		gotoApplication() {
			router.push({ name: 'review-application' });
		},
	},
};
</script>

<template>
	<div>
		<!-- Modal Schedule Request START-->
		<b-modal id="scheduleRequestModal" centered title="Reschedule Request" title-class="font-18" hide-footer>
			<form>
				<h5 class="mt-4 mb-4">{{ reScheduleRequestForm.role }} at {{ reScheduleRequestForm.building }} in {{ reScheduleRequestForm.location }} at {{ reScheduleRequestForm.time }} on {{ reScheduleRequestForm.date }}</h5>
				<div class="mb-3">
					<label>Reason For Reschedule</label>
					<div>
						<textarea
							v-model="reScheduleRequestForm.comment"
							class="form-control"
							name="comment"
							rows="3"
							placeholder="Enter Reason"
							:class="{
								'is-invalid': typeSubmit && $v.reScheduleRequestForm.comment.$error,
							}"
						></textarea>
						<div v-if="typeSubmit && $v.reScheduleRequestForm.comment.$error" class="invalid-feedback">
							<span v-if="!$v.reScheduleRequestForm.comment.required">Reason is required.</span>
						</div>
					</div>
				</div>

				<div class="mb-5">
					<div>
						<button type="button" @click="sendRequest" class="btn btn-primary">Send Request</button>
					</div>
				</div>
			</form>
		</b-modal>
		<!-- Modal Schedule Request END-->

		<!-- Modal Available Roles START-->
		<b-modal id="availableRolesModal" size="xl" centered title="Available Roles" title-class="font-18" hide-footer>
			<form>
				<div class="row mt-5">
					<div class="mb-5 col-md-3">
						<div>
							<b-form-select class="form-select" v-model="roleFilterForm.category_id" :options="categories">
								<option slot="first" :value="null">Select Category</option>
							</b-form-select>
							<small>Select Category</small>
						</div>
					</div>

					<div class="mb-5 col-md-3">
						<div>
							<b-form-select class="form-select" v-model="roleFilterForm.role_id" :options="roles">
								<option slot="first" :value="null">Select Role</option>
							</b-form-select>
						</div>
						<small>Select Role</small>
					</div>

					<div class="col-md-2">
						<div class="mb-5">
							<div>
								<button type="button" @click="filterAvailableRoles()" class="btn btn-primary">Search Options</button>
							</div>
						</div>
					</div>
				</div>
				<!--row end-->
			</form>

			<div class="table-responsive">
				<table class="table table-bordered table-hover table-striped align-middle mb-5">
					<thead>
						<tr>
							<th>Role</th>
							<th>Time Slots</th>
							<th>Request</th>
						</tr>
					</thead>

					<tbody>
						<tr v-for="(availableRole, index) in this.availableRoles" :key="index">
							<td>
								{{ availableRole.name }}
							</td>
							<td>
								{{ availableRole.time_slots }}
							</td>
							<td>
								<input type="checkbox" :value="availableRole.id" @change="pushRoleId($event)" />
							</td>
						</tr>
					</tbody>
				</table>

				<div class="mb-5">
					<div>
						<button type="button" @click="sendRoleRequest()" class="btn btn-primary">Send Request</button>
					</div>
				</div>
			</div>
		</b-modal>

		<Header></Header>
		<div id="main-title" class="secondary">
			<div class="container">
				<div class="row">
					<div class="col-12 col-lg-6 align-self-center">
						<h3 class="title">Schedule Roles</h3>
					</div>
					<div class="col-12 col-lg-6 text-left text-lg-end align-self-center">
						<p class="need-help">Need Help ? <a href="javascript:">Contact Us</a></p>
						<!-- <logout-button></logout-button> -->
					</div>
				</div>
			</div>
		</div>

		<div class="custom-form d-flex container pb-5 pt-5">
			<b-button class="btn-custom ms-0" variant="custom" @click="gotoProfile"> Profile Information </b-button>
			<b-button v-if="userData['user_type_id'] === 4" class="btn-custom" variant="custom" @click="gotoRoles"> Roles </b-button>
			<b-button v-if="userData['user_type_id'] === 3 || (userData['user_type_id'] === 4 && userData['is_upgraded'] === 1)" class="btn-custom" variant="custom" @click="gotoMentorHours"> Mentor Hours </b-button>
			<b-button class="btn-custom" variant="custom" v-if="contactInfoForm.status !== 1" @click="gotoApplication"> Review Application </b-button>
		</div>
		<!-- main content -->
		<div class="card custom-form pt-5 pb-4 container" v-if="userId">
			<div class="card-body">
				<div class="card-heade">
					<button type="button" class="btn btn-primary" variant="custom" @click="showAvailableRolesModal()">View Available Roles</button>
				</div>

				<div class="row mt-3">
					<div class="col-md-12 px-0 cards-cont">
						<div v-if="this.assignedRoles">
							<div class="table-responsive">
								<table class="table table-bordered table-hover table-striped align-middle mb-0">
									<thead v-if="noRecord || isLoading">
										<tr v-if="noRecord">
											<td colspan="8" class="p-0">
												<p class="font-size-16 text-center mt-2 mb-0">Record Not Found!</p>
											</td>
										</tr>

										<tr v-if="isLoading">
											<td colspan="8" class="text-center p-0">
												<b-spinner class="m-2" variant="primary" role="status"></b-spinner>
											</td>
										</tr>
									</thead>

									<thead v-if="!noRecord && !isLoading">
										<tr>
											<th>Status</th>
											<th>Role</th>
											<th>Location</th>
											<th>Building</th>
											<th>Date</th>
											<th>Time</th>
											<th>Approver</th>
											<th>Action</th>
										</tr>
									</thead>

									<tbody v-if="!noRecord && !isLoading">
										<tr v-for="(role, index) in this.assignedRoles" :key="index">
											<td>
												{{ role.status }}
											</td>
											<td>
												{{ role.role }}
											</td>
											<td>
												{{ role.location }}
											</td>
											<td>
												{{ role.building }}
											</td>
											<td>
												{{ dateFormatter(role.date) | moment }}
											</td>
											<td>{{ role.start_time }} to {{ role.end_time }}</td>
											<td>
												{{ role.approver }}
											</td>

											<td style="position: relative">
												<button type="button" @click="showScheduleRequestModal(index)" class="btn btn-primary">Schedule Request</button>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="custom-form" v-else>
			<div class="text-center mt-3">
				<b-button class="btn-custom" variant="custom" @click="loginPage"> Login </b-button>
			</div>
		</div>

		<Footer></Footer>
	</div>
</template>
<style scoped>
.btn.btn-primary {
	background: #d0885a !important;
	border: 1px solid #d0885a !important;
}
.custom-form label {
	font-size: 16px;
	margin-left: 16px;
}
.media:hover .edit-box {
	position: absolute;
	top: 0px;
	bottom: 0px;
	left: 0px;
	right: 0px;
	visibility: visible;
	opacity: 1;
}
.media .edit-box {
	visibility: hidden;
	opacity: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: rgb(0 0 0 / 0.08);
}
.roles-boxes {
	display: flex;
	flex-direction: column;
	justify-content: center;
}
.box {
	padding: 5px;
	text-align: center;
}
.box.mentor {
	border: 2px solid #556ee6;
}
.box.donor {
	border: 2px solid #34c38f;
}
.box.p-alum {
	border: 2px solid #50a5f1;
}
.box.volunteer {
	border: 2px solid #f1b44c;
}
.chck-icon {
	font-size: 130px;
}
.pb-1-5rem {
	padding-bottom: 1.5rem !important;
}
.avatar-box {
	width: 30%;
	overflow: hidden;
	margin: 0 auto;
}
.img-wrap {
	height: 7.5rem;
	width: 7.5rem;
	position: relative;
	border: 2px solid #f6f6f6;
	border-radius: 100%;
	overflow: hidden;
}
.img-wrap img {
	width: 100%;
	position: absolute;
	left: 0px;
	right: 0px;
	top: 50%;
	transform: translateY(-50%);
}
.preview {
	position: relative;
}
.preview img {
	width: 100%;
}
.btn-remove {
	background-color: #ebecec;
	position: absolute;
	top: -15px;
	right: -15px;
	padding: 0px;
	font-size: 24px;
	border-radius: 100%;
	width: 30px;
	height: 30px;
	line-height: 30px;
	-webkit-box-shadow: 0 0.75rem 1.5rem rgb(18 38 63 / 3%);
	box-shadow: 0 0.75rem 1.5rem rgb(18 38 63 / 3%);
}
</style>
